// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"274":"7d37891f","774":"ec5a3058"}[chunkId] + ".chunk.js";
};